import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { MatTooltip } from "@angular/material/tooltip";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ReviewInfo } from "@teammood/timeline";
import { format } from "date-fns";

@Component({
    selector: "review-badge",
    templateUrl: "./review-badge.component.html",
    styleUrls: ['./review-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
        MatTooltip,
    ]
})
export class ReviewBadgeComponent {

    @Input() reviewInfo: ReviewInfo[];

    constructor(private translateService: TranslateService,){}

    protected reviewsLabel(): string {
        if (this.reviewInfo) {
            return this.translateService.instant('feedback_reviewed.desc') + ' ' +
                this.reviewInfo.map(review => {
                    const date = format(review.date, "E dd MMM");
                    return `${review.name} (${date})`
                }).join(", ");
        } else {
            return ""
        }
    }
}